


















































































































import { ShowcaseVueGB } from "@/extensions/products/ShowcaseVueGB";
import ShowCaseDepositsList from "@/components/showcase/ShowcaseDepositsList.vue";
import ShowCaseCreditsList from "@/components/showcase/ShowCaseCreditsList.vue";
import SumInput from "@/components/app/SumInput.vue";
import BackLink from "@/components/app/BackLink.vue";
import { Component } from "vue-property-decorator";
import ShowCaseCreditCalc from "./ShowCaseCreditCalc.vue";
import ShowCaseTypesList from "@/components/showcase/ShowCaseTypesList.vue";
import ShowCaseFinProduct from "@/components/showcase/ShowCaseFinProduct.vue";
import ShowCaseBlocks from "@/components/showcase/ShowCaseBlocks.vue";

@Component({
  components: {
    ShowCaseDepositsList,
    ShowCaseCreditCalc,
    ShowCaseCreditsList,
    ShowCaseTypesList,
    ShowCaseFinProduct,
    ShowCaseBlocks,
    SumInput,
    BackLink
  }
})
export default class ShowCasePage extends ShowcaseVueGB {
}
